import React from "react";
import { observer } from "mobx-react";
import { Col, Row } from "react-bootstrap";
import { isEmpty } from "lodash";

import { useAppStore } from "../../providers/AppStoreProvider";
import { Resource } from "../../components/Resource/Resource";

export const Resources = observer(() => {
  const store = useAppStore();

  return (
    store.currentLesson?.resources?.length > 0 && (
      <div className="lesson-resources mb-4">
        <h5 className="fw-bold mb-3">Tài nguyên</h5>
        <Row lg={{ cols: 2 }} className="row-cols-1 g-3">
          {store.currentLesson.resources.map(
            (resource, index) =>
              !isEmpty(resource.link) && (
                <Col key={index}>
                  <Resource resource={resource} />
                </Col>
              ),
          )}
        </Row>
      </div>
    )
  );
});
